<ng-container *transloco="let t">
  <ld-base-modal
    [title]="title() || t('forceUpdateTitle')"
    [showCloseButton]="false"
    [closeOnBackdropClick]="false"
    (closeModal)="onUpdate()"
  >
    <div modal-content>
      <div id="force-update-modal-icon" class="pt-8 pb-4 flex justify-center">
        <svg
          xmlns="http://www.w3.org/2000/svg"
          class="w-12 h-12 text-ld-primary"
          fill="none"
          viewBox="0 0 24 24"
          stroke="currentColor"
          stroke-width="2"
        >
          <path
            stroke-linecap="round"
            stroke-linejoin="round"
            d="M4 16v1a3 3 0 003 3h10a3 3 0 003-3v-1m-4-8l-4-4m0 0L8 8m4-4v12"
          />
        </svg>
      </div>

      <div id="force-update-modal-body" class="px-6 pb-6 text-center">
        <p id="force-update-modal-message" class="text-ld-neutral-600 mb-4">
          {{ message() || t('forceUpdateMessage') }}
        </p>

        @if (currentVersion() && minimumVersion()) {
          <div id="force-update-modal-versions" class="text-sm text-ld-neutral-500 bg-ld-neutral-50 rounded-lg p-3">
            <p id="force-update-current-version">
              {{ t('forceUpdateCurrentVersion') }}:
              <span class="font-medium">{{ currentVersion() }}</span>
            </p>
            <p id="force-update-required-version">
              {{ t('forceUpdateRequiredVersion') }}:
              <span class="font-medium">{{ minimumVersion() }}</span>
            </p>
          </div>
        }
      </div>
    </div>

    <div modal-footer>
      <button
        id="force-update-modal-update-button"
        type="button"
        class="btn-primary-ld-purple"
        [disabled]="isLoading()"
        (click)="onUpdate()"
      >
        @if (isLoading()) {
          <mat-spinner diameter="20" class="!w-5 !h-5 [&_circle]:!stroke-white"></mat-spinner>
        }
        {{ updateButtonText() || t('forceUpdateButton') }}
      </button>
    </div>
  </ld-base-modal>
</ng-container>
